import React from 'react';
import { Link } from 'react-router-dom';

interface UnauthorizedAccessProps {
    message?: string;
    showBackButton?: boolean;
}

/**
 * Component to display when user doesn't have permission to access a resource
 */
export const UnauthorizedAccess: React.FC<UnauthorizedAccessProps> = ({
    message = "You don't have permission to access this resource.",
    showBackButton = true
}) => {
    return (
        <div className="container-fluid">
            <div className="row justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                <div className="col-md-6 text-center">
                    <div className="card border-0 shadow-sm">
                        <div className="card-body p-5">
                            <div className="mb-4">
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="80" 
                                    height="80" 
                                    fill="currentColor" 
                                    className="bi bi-shield-exclamation text-warning" 
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/>
                                    <path d="M7.001 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L7.1 4.995z"/>
                                </svg>
                            </div>
                            
                            <h3 className="mb-3 text-dark">Access Restricted</h3>
                            <p className="text-muted mb-4">{message}</p>
                            
                            <div className="d-flex flex-column flex-md-row gap-3 justify-content-center">
                                {showBackButton && (
                                    <button 
                                        onClick={() => window.history.back()} 
                                        className="btn btn-outline-secondary"
                                    >
                                        <svg 
                                            xmlns="http://www.w3.org/2000/svg" 
                                            width="16" 
                                            height="16" 
                                            fill="currentColor" 
                                            className="bi bi-arrow-left me-2" 
                                            viewBox="0 0 16 16"
                                        >
                                            <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
                                        </svg>
                                        Go Back
                                    </button>
                                )}
                                
                                <Link to="/dashboard" className="btn btn-primary">
                                    <svg 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        width="16" 
                                        height="16" 
                                        fill="currentColor" 
                                        className="bi bi-house me-2" 
                                        viewBox="0 0 16 16"
                                    >
                                        <path fillRule="evenodd" d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"/>
                                        <path fillRule="evenodd" d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"/>
                                    </svg>
                                    Go to Dashboard
                                </Link>
                            </div>
                            
                            <div className="mt-4 pt-4 border-top">
                                <small className="text-muted">
                                    If you believe you should have access to this resource, please contact your system administrator.
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
